/**
 * The in-app drag of workspace files (Files manager cards/rows, the editor's uploads panel):
 * `application/x-xcreative-files` carries `{ ids }`, plus the file names as text/plain. Custom
 * types survive a drag between two windows of the same browser, so a card dragged from the Files
 * page in one window drops onto a slide in another.
 */
export const FILES_DRAG = 'application/x-xcreative-files';

type WithTransfer = { dataTransfer: DataTransfer | null };

export const isFilesDrag = (e: WithTransfer) => !!e.dataTransfer && [...e.dataTransfer.types].includes(FILES_DRAG);

/** Ids of the dragged workspace files (null: not a files drag; [] while the data is protected or malformed). */
export function draggedFileIds(e: WithTransfer): string[] | null {
  if (!isFilesDrag(e)) return null;
  try {
    const v = JSON.parse(e.dataTransfer!.getData(FILES_DRAG)) as { ids?: unknown };
    return Array.isArray(v.ids) ? v.ids.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

/** Start a files drag: movable into folders, copyable onto slides. */
export function setFilesDrag(dt: DataTransfer, ids: string[], names: string[]): void {
  dt.setData(FILES_DRAG, JSON.stringify({ ids }));
  dt.setData('text/plain', names.join('\n'));
  dt.effectAllowed = 'copyMove';
}
